import { render, staticRenderFns } from "./Zysp.vue?vue&type=template&id=4135492a&scoped=true&"
import script from "./Zysp.vue?vue&type=script&lang=js&"
export * from "./Zysp.vue?vue&type=script&lang=js&"
import style0 from "../style.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./Zysp.vue?vue&type=style&index=1&id=4135492a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4135492a",
  null
  
)

export default component.exports